// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { KeyRound as RawKeyRound } from "lucide-react";
export const KeyRound = /* @__PURE__ */ createIcon(RawKeyRound, "KeyRound", 2);
